import type { GenericWrapperArgument } from '@ingenico/util-mfe';
import { bootstrapDeviceManagement } from '../domain/bootstrap';
import type { DeviceManagementApiPort } from '../domain/domain/hexa/ports/api.model';
import type { DeviceManagementSpiPort } from '../domain/domain/hexa/ports/spi.model';

export function genericWrapper({
  spi,
  setApi,
}: GenericWrapperArgument<DeviceManagementApiPort, DeviceManagementSpiPort>): void {
  const { api, routes } = bootstrapDeviceManagement({
    spi,
  });
  setApi(api, routes);
}
